import React, { useEffect, useState } from 'react';
import FaqService from 'services/faqService';

import * as S from './styles';

const DoubtForm = ({ onConclude }) => {
	const [clientType, setClienteType] = useState({ value: '', hasError: false });
	const [clientName, setClienteName] = useState({ value: '', hasError: false });
	const [phoneNumber, setPhoneNumber] = useState({ value: '', hasError: false });
	const [email, setEmail] = useState({ value: '', hasError: false });
	const [subject, setSubject] = useState({ value: '', hasError: false });
	const [eventName, setEventName] = useState({ value: '' });
	const [purchaseCode, setPurchaseCode] = useState({ value: '' });
	const [description, setDescription] = useState({ value: '', hasError: false });

    const [invalidForm, setInvalidForm] = useState(true);
    const [isSending, setIsSending] = useState(false);

    const [attachment, setAttachment] = useState({ name: 'Selecionar arquivo', file: null });

    useEffect(() => {
		validateForm();
	}, [clientType, clientName, phoneNumber, email, subject, description]);


	const changeClientType = (ev) => {
		ev.persist();
		setClienteType(() => ({
			hasError: !ev.target.value,
			value: ev.target.value
		}));
	}

	const changeClientName = (ev) => {
		ev.persist();
        const cleanValue = ev.target.value.trimStart();
		setClienteName(() => ({
			hasError: ev.target.value.length === 0,
			value: cleanValue
		}));
	}

	const changePhoneNumber = (ev) => {
		ev.persist();
		const cleanValue = ev.target.value.replace(/\D/g,'').substring(0, 11);
		setPhoneNumber(() => ({
			hasError: cleanValue.length === 0 || cleanValue.length < 11,
			value: cleanValue
		}));
	}

	const changeEmail = (ev) => {
		ev.persist();
		setEmail(() => ({
			hasError: ev.target.value.length === 0 || !ev.target.value.match(/^[\w\.\-_]{1,}@[\w\.\-]{6,}/),
			value: ev.target.value
		}));
	}

    const changeSubject = (ev) => {
		ev.persist();
		setSubject(() => ({
			hasError: !ev.target.value,
			value: ev.target.value
		}));
	}

    const changeEventName = (ev) => {
		ev.persist();
        const cleanValue = ev.target.value.trimStart();
		setEventName(() => ({
			value: cleanValue
		}));
	}

    const changePurchaseCode = (ev) => {
		ev.persist();
        const cleanValue = ev.target.value.replace(/[^a-z0-9]/ig,'');
		setPurchaseCode(() => ({
			value: cleanValue
		}));
	}

    const changeDescription = (ev) => {
		ev.persist();
        const cleanValue = ev.target.value.trimStart();
		setDescription(() => ({
			hasError: ev.target.value.length === 0,
			value: cleanValue
		}));
	}

    const validateForm = () => {
		if (!clientType.value || !clientName.value || !phoneNumber.value || !email.value || !subject.value || !description.value) {
			setInvalidForm(true);
			return;
		}

		if (clientType.hasError || clientName.hasError || phoneNumber.hasError || email.hasError || subject.hasError  || description.hasError) {
			setInvalidForm(true);
			return;
		}

		setInvalidForm(false);
	}

    const changeAttachment = (file) => {
        setAttachment({ name: file.name, file: file });
    }

    const removeAttachment = (e) => {
        e.preventDefault();

        if (attachment.file) {
            setAttachment({ name: 'Selecionar arquivo', file: null });
        }
    }

    const send = (e) => {
        e.preventDefault();
        setIsSending(() => true);

		const payload = {
            clientType: clientType.value,
            clientName: clientName.value,
            phoneNumber: phoneNumber.value,
            email: email.value,
            subject: subject.value,
            eventName: eventName.value,
            purchaseCode: purchaseCode.value,
            description: description.value,
        }

        const formData = new FormData();
        formData.append('body', new Blob([JSON.stringify(payload)], { type: 'application/json' }));
		attachment.file && formData.append('file', attachment.file);

        FaqService.sendDoubt(formData)
            .then(() => {
                onConclude();
                window.scrollTo(0,0);
            })
            .finally(() => setIsSending(() => false))
	}

    return (
        <S.FormWrapper onSubmit={send}>
            <S.InputGroup>
                <S.Label>Tipo de cliente *</S.Label>
                <S.Select className={clientType.hasError && 'hasError'} value={clientType.value} onChange={changeClientType}>
                    <option value="" disabled>Selecione</option>
                    <option value="PARTICIPANT">Participante de eventos</option>
                    <option value="ORGANIZER">Organizador de eventos</option>
                </S.Select>
                <S.MessageError>Campo inválido</S.MessageError>
            </S.InputGroup>

            <S.InputGroup>
                <S.Label>Nome *</S.Label>
                <S.Input className={clientName.hasError && 'hasError'} placeholder="Seu nome" value={clientName.value} onChange={changeClientName} />
                <S.MessageError>Campo inválido</S.MessageError>
            </S.InputGroup>

            <S.FormInline>
                <S.InputGroup>
                    <S.Label>Telefone *</S.Label>
                    <S.MaskInput className={phoneNumber.hasError && 'hasError'} mask="(99) 99999-9999" placeholder="(99) 99999-9999" value={phoneNumber.value} onChange={changePhoneNumber} />
                    <S.MessageError>Campo inválido</S.MessageError>
                </S.InputGroup>

                <S.InputGroup>
                    <S.Label>E-mail *</S.Label>
                    <S.Input className={email.hasError && 'hasError'} placeholder="seuemail@mail.com" value={email.value} onChange={changeEmail} />
                    <S.MessageError>Campo inválido</S.MessageError>
                </S.InputGroup>
            </S.FormInline>

            <S.InputGroup>
                <S.Label>Assunto *</S.Label>
                <S.Select className={subject.hasError && 'hasError'} value={subject.value} onChange={changeSubject}>
                    <option value="" disabled>Selecione</option>
                    <option value="BENEFIT_DISCOUNT">Dúvidas sobre benefícios e descontos</option>
                    <option value="EVENT_INFORMATION">Informações sobre o evento</option>
                    <option value="EVENT_COMPLAINT">Reclamação de evento</option>
                    <option value="RESENDING_ADMISSION">Reenvio de ingresso</option>
                    <option value="CARRIER_CHANGE">Troca de portador</option>
                    <option value="OTHER">Outros</option>
                </S.Select>
                <S.MessageError>Campo inválido</S.MessageError>
            </S.InputGroup>

            <S.FormInline>
                <S.InputGroup>
                    <S.Label>Nome do evento</S.Label>
                    <S.Input className={eventName.hasError && 'hasError'} placeholder="Escreva o nome do evento" value={eventName.value} onChange={changeEventName} />
                    <S.MessageError>Campo inválido</S.MessageError>
                </S.InputGroup>

                <S.InputGroup>
                    <S.Label>Número do pedido</S.Label>
                    <S.Input className={purchaseCode.hasError && 'hasError'} placeholder="XXXXXXXX" value={purchaseCode.value} onChange={changePurchaseCode} />
                    <S.MessageError>Campo inválido</S.MessageError>
                </S.InputGroup>
            </S.FormInline>

            <S.InputGroup>
                <S.Label>Descrição *</S.Label>
                <S.TextArea className={description.hasError && 'hasError'} placeholder="Escreva sua dúvida ou solicitação" value={description.value} onChange={changeDescription} />
                <S.MessageError>Campo inválido</S.MessageError>
            </S.InputGroup>

            <S.InputGroup>
                <S.Label>Anexo</S.Label>
                <S.InputFileWrapper>
                    <S.InputFileTrigger htmlFor="file">
                        <S.InputFileName>{attachment.name}</S.InputFileName>
                        <S.InputFileIcon hasFile={attachment.file !== null} onClick={removeAttachment}/>
                    </S.InputFileTrigger>
                    <input id="file" type="file" style={{display: 'none'}} onChange={$event => changeAttachment($event.target.files[0])} />
                </S.InputFileWrapper>
            </S.InputGroup>

            <S.ButtonWrapper>
                <S.Button disabled={invalidForm || isSending} onClick={send}>{isSending ? 'Enviando' : 'Enviar'}</S.Button>
            </S.ButtonWrapper>
        </S.FormWrapper>
    );
}

export default DoubtForm;